<template>
  <div class="dashboard">
    <div class="row">
      <div class="flex xs12 lg12">
        <siteList />
      </div>
    </div>
    <div class="row">
      <div class="flex xs12 lg12">
        <site-details />
      </div>
    </div>
  </div>
</template>

<script>
import SiteList from './SiteList'
import SiteDetails from './SiteDetails'
export default {
  name: 'alerts',
  components: {
    SiteList,
    SiteDetails,
  },
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0 !important;
  }
}
</style>
